import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FileService, MainAppService } from '@medappsware/shared';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})

export class AppComponent {
  sideNav: boolean = false;
  title = 'DCWare';
  constructor(private readonly mainAppService: MainAppService, private readonly fileService: FileService){
      this.mainAppService.setAPIURL(environment.apiURL);
      this.fileService.setFilesApiUrl(environment.filesApiUrl);
      this.mainAppService.setAuthURL(environment.authApiUrl);
      this.mainAppService.setFilesApiUrl(environment.filesApiUrl);
  }
}
